import { render, staticRenderFns } from "./sendMessage.vue?vue&type=template&id=ce949e54&scoped=true&"
import script from "./sendMessage.vue?vue&type=script&lang=js&"
export * from "./sendMessage.vue?vue&type=script&lang=js&"
import style0 from "./sendMessage.vue?vue&type=style&index=0&id=ce949e54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce949e54",
  null
  
)

export default component.exports